/** Ошибки сохранения файла на диск: сообщение Error — код из этого перечисления */
export enum EnumFileSaveError {
  /** Нет ни File System Access API, ни действующего service worker */
  NOT_SUPPORTED = 'file_save_not_supported',
  /** Пользователь закрыл окно «Сохранить как» */
  CANCELLED = 'file_save_cancelled',
  /** Поток через service worker оборван */
  STREAM_CLOSED = 'file_save_stream_closed',
}
